import { AutogenLayoutMobileCommSendLoadOptionsList } from "./autogen/AutogenLayoutMobileCommSendLoadOptionsList";

export class MobileCommSendLoadOptionsList extends AutogenLayoutMobileCommSendLoadOptionsList {
    async onLoad() {
    }
}
